import React from 'react';
import Container from '../../../../components/Container';
import styles from './Desktop.module.css';
import Popup from '../../../../components/Popup/Popup';
import PopupContent from '../../../../components/Popup/PopupContent';
import Content from '../../../../components/Content'
import Body from '../../components/Body';
import TipsInfo from '../../components/TipsInfo';

export default function Desktop(props) {
  const { popup, closePopup, currency } = props;

  const getPopupStyle = () => {
    let popupStyle = {};
    if (popup && popup.type === "spinner") {
      popupStyle = { width: "60%" };
    } else if (popup && popup.type === "popup") {
      popupStyle = { width: "30%" };
    } else if (popup && popup.type === "server-tips") {
      popupStyle = { width: "50%" };
    }
    return popupStyle;
  };

  const getPopupContent = () => {
    if (!popup) return;
    switch (popup.type) {
      case "server-tips": {
        return <TipsInfo tipsData={popup.metaData} onClose={closePopup} currency={currency} />
      }
      default: {
        return <PopupContent {...popup} />;
      }
    }
  };

  return (
    <Container style={styles.container}>
      <Popup visible={!!popup} popupStyle={getPopupStyle()} closePopup={closePopup}>
      {getPopupContent()}
      </Popup>
      <Content style={styles.content}>
        <Body {...props} />
      </Content>
    </Container>
  )
}